import moment from "moment";

const getEntryType = (title, type, list) => {
    const slots = [];
    for (const item of list) {
        slots.push({
            title: item,
            item: null
        })
    }
    return {
        title: title,
        type: type,
        list: slots
    }
}

export default (start, end, cache) => {
    const itinerary = cache ? cache : {
        start: start,
        end: end,
        days: []
    };
    let current = moment(start).format('YYYY-MM-DD');


    const days = [...itinerary.days];
    const newDays = [];

    while (current <= end) {
        const index = newDays.length;
        if (days[index]) {
            newDays.push(days[index])
        } else {
            newDays.push({
                date: current,
                items: [
                    getEntryType('Things to do', 'Activity', ['Morning', 'Afternoon', 'Evening', 'Extra 1', 'Extra 2']),
                    getEntryType('Taste', 'Food', ['Morning', 'Afternoon', 'Evening', 'Extra 1', 'Extra 2']),
                    getEntryType('Stay', 'Accommodation', ['Option 1', 'Option 2', 'Option 3']),
                    getEntryType('What\'s on', 'Event', ['Option 1', 'Option 2', 'Option 3']),
                ]
            })
        }
        current = moment(current).add(1, 'd').format('YYYY-MM-DD');
    }

    itinerary.days = newDays;

    console.log(itinerary);

    return itinerary;
}
